export default {
    home: "Home",
    venueFastQuery: "Fast Query",
    venueFastQueryOld: "Fast Query Old",
    cardNumberManagement: "Card Number Management",
    cardNumberAssignment: "Card Number Assignment",
    cardDetail: "Card Number Detail",
    changeIp: "Change Server",
    batchChangeIp: "Batch Change IP",
    cdrListToday: "CDR List Today",
    wirteCardMissingQuery: "Write Card Miss Query",
    merchantManagement: "Merchant Management",
    agentManagement: "Agent Management",
    packageManagement: "Package Management",
    packageResources: "Package Resources",
    roleManagement: "Role Management",
    userActionLog: "User Action Log",
    statisticalReport: "Statistical Report",
    rechargeLog: "Recharge Log",
    topUpLog: "TopUp Log",
    withdrawLog: "Withdraw Package Log",
    actionCode: 'Type',
    cdrSimList: "CDR SIM List",
    keyword:"Please input keyword to search",
    queryFail: "Query data failed",
    noData:"No data",
    loading: "Loading",
    backTop:'BackTop',
    taskTopupList: "Topup Task List",
    orderFile: 'Order File',
    changeRoute: 'Change Line',
    routeRate: 'Line Rate',
    agentIpFeeLogList: "Line cost details",
    switchLanguages: "Language",
    simplifiedChinese: "简体中文",
    english: "English",
    personalInformation: 'Personal Information',
    logout:'Logout',
    all: "All",
    type: 'Type',
    package:'Package',
    packageDetail:'Package Details',
    globalMsisdnPackage:'Global Msisdn Package',
    noticeAccountExpired:'The account has expired, please log in again!',
    selected:'Selected',
    operator: 'Operator',
    operationSuccess: "Operation Successs",
    importFail: "Import Fail",
    exportData: 'Export Data',
    remainingImsi:'Remaining Amount(IMSI)',
    pleaseEnter:'Please enter',
    contact:'Customer Service',
    day: "Day",
    noPackageData:"No package data",
    clearPackageData:"Package cleared",
    nonSupportRecharge:"Package price is empty, can not recharge!",
    otaSimManage:"OTA Card Management",
    otaPackageManage:"OTA Package Management",
    taskId: 'Task ID',
    accountStatus:{
        inactive:'Inactive',
        activated:'Activated',
        close: 'Close',
        expired:'Expired',
        HLRTerminated:'HLR Terminated'
    },
    addMerchantMember:'Add Merchant Member',
    other: 'Other',
    common:{
        search:"Search",
        reset: 'Reset',
        available:'Available',
        disable:"Disable",
        enable:"Enable",
        clear: 'Clear',
        clearIpGroup: 'Clear Route',
        assign:"Assign",
        edit:'Edit',
        notice: "Notice",
        confirmDelete: 'Are you sure to delete?',
        cardSearch: 'Please enter card number to search',
        ok:'OK',
        cancel:'Cancel',
        close:'Close',
        batchClose:'Batch Close',
        editAssign: 'Edit Assign',
        add: "Add",
        recharge: "Recharge",
        deduction: "Deduction",
        other: 'Other',
        unlimit:"Unlimit",
        pleaseChoose: "Please Choose",
        present: 'Present',
        accountStatus:{
            inactive:'Inactive',
            activated:'Activated',
            close: 'Close',
            expired:'Expired',
            HLRTerminated:'HLR Terminated'
        },
        packageStatus:{
            inactive:'Inactive',
            activated:'Activated',
            close: 'Close',
            expired:'Expired'
        },
        payType:{
            prepay:'Prepay',
            postpay:'Postpay',
        },
        byType:{
            segment: 'By Segment',
            number: 'By Count',
            scattered: 'By Scattered',
        },
        account: "Card Number",
        agent: "Agent",
        productName: "Package Name",
        businessOwner: "Merchant",
        batchTopup:'Batch Top-up',
        batchRecharge: "Batch Top-up（Excel) ",
        currImsi: "IMSI",
        pkgStatus: "Package Status",
        status: "Status",
        cardStatus: "Card Status",
        delete:'Delete',
        operation: 'Operation',
        contact:'Contact',
        transfer:'Transfer',
        address:'Address',
        phone:'Phone',
        operator:'Operator',
        createTime:'CreateTime',
        viewDetails:'See Details',
        rate: 'Rate ',
        viewPackage: 'View Package',
        temp:'Top-up Template',
        editAgentPassword:'Change Password',
        havePackage:'Existing packages',
        areYouSureContinue:'Are you sure you want to continue',
        topupExcelNotice:'Please clear the card with the same package and upload the file again',
        bossId:'BossId',
        currDataSpeed:'Current Data Speed',
        fixExpiryTime:'Promotion Expiration Time',
        onSale:'OnSale',
        pleaseInput:'Please input ',
        upShelf:'Up Shelf',
        downShelf:'Down Shelf',
        cardExpiryTime:'Card Expiration Time',
        provider:'Provider',
        class: 'Class',
        isOta: 'Is OTA',
        no:'No',
        yes:'Yes',
        syncProductNotice:'Are you sure you want to synchronize product information ?',
        syncOperateFail:'Failed to synchronize product information',
        syncOperateSuccess:'Product Synchronization succeeded !',
        method: 'Method',
        accounts: 'Card NO',
        accounts_placeholder: 'Please enter a card NO per line',
        account_placeholder: 'Please enter the start and end card NO',
        continuity: 'Continuous card NO',
        nonContinuity: 'Noncontinuous card NO',
        accountStart: 'Start card NO',
        accountEnd: 'End card NO',
        batchChangeIp: 'Batch Change IP',
        ipGroup: 'Route',
        changeIpType: 'Change Route Billing Type',
        changeIpTypeOp:{
            byCount: 'By Count',
            perMensem: 'By Month'
        },
        changeAccountObject: 'Accounting Object',
        changeAccountObjectOp:{
            account: 'Account',
            imsi: 'IMSI'
        },
        packageSearch: 'Package Search',
        routeSearch: 'Route Search',
        addChangeIpRate: 'Add Rate',
        effectiveStartTime : 'Effective Start Time',
        effectiveEndTime : 'Effective End Time',
        editChangeIpRate: 'Edit Rate',
        effectiveEndMonth: 'Valid Month',
        fupType: 'Fup Type',
        fupType_0: "Unknown",
        fupType_1: "Daily",
        fupType_2: "Total",
        packageRechargeFee: "Package Recharge Fee",
        packageCancellationRefund: "Package Cancel Refund",
        cancellationServiceFee: "Cancel Service Fee",
        balanceCredit: "Balance Credit",
        balanceDeduction: "Balance Deduction",
        eSIMIssuanceFee: "eSIM Issuance Fee",
        lineChangeFee: "Line Change  Fee",
        lineMonthlyRentalFee: "Line Monthly Rental Fee",
        activeImsiFee: "Active IMSI Fee"
    },
    fastQuery:{
        esimDetail: 'Esim Info',
        esimStatus: 'Esim Status',
        esimInstallationCount: 'Esim Installation Count',
        esimInstallTime: 'Esim Install Time',
        esimInstalledDevice: 'Esim Installed Device',
        topupStatus: 'Topup Status',
        search: "Please input IMSI or card number to search",
        nodata: "",
        account: "Card Number",
        taskid: "Task",
        basicInfo: "Basic Information",
        currImsi: "IMSI",
        cardType: "Card Type",
        enable: "Available Or Not",
        accountStatus: "Card Status",
        payType: "Payment Type",
        balance: "Balance",
        dataUsageToday: "Data Usage Today",
        dataUsageTotal: "Data Usage Total",
        voiceTotal: "Voice Total",
        voiceMtTotal: "Voice MT Total",
        voiceMoTotal: "Voice MO Total",
        smsTotal: "Sms Total",
        packageStatus: "Package Status",
        validMonth: "Valid Month(Month)",
        packageActiveTime: "Package Activation Time",
        packageExpiryTime: "Package Expiration Time",
        createTime: " Create Time",
        packageType:'Package Type',
        bindImsiData:{
            bindData: "Binding Information",
            serialNumber: "Serial Number",
            bindImsi: "Bound IMSI",
            bindTime: "Binding Time",
        },
        ratePackageTitle:'Rate Package',
        dataPackage: 'Package',
        product:{
            syncProduct: 'Sync Product',
            addProduct:'Add Product',
            editProduct:'Edit Product',
            delProduct:'Delte',
            batchDelProduct:'Batch Delete',
            information: "Package Information",
            productId: "Package ID",
            productName: "Package Name",
            validDays: "Valid Days",
            dataTotal: "Data Total",
            voiceTotal: "Voice Total Minutes",
            voiceMt: "Voice MT",
            voiceMo: "Voice MO",
            smsTotal: "Sms Total",
            dataSpeedDefault: "Data Speed Default",
            dataQuota: "Quota Data",
            validDayType: "Valid Day Type",
            validDayTypeObj:{
                hours:'24 Hours',
                day: '1 Day'
            },
            rateGroupName: "Rate Group Name",
            zoneVoiceMtName: "Voice MT areas",
            zoneVoiceMoName: "Zone Voice MO Name",
            zoneDataName: "Data Zone",
            zoneSmsName:"Zone Sms Name",
            dataFupName:"Data Fup Name",
            voiceFupName:"Voice Fup Name",
            operator:{
                information: "Operator Information",
                name: "Name",
                countryName: "Country Name",
                countryCode: "Country Code"
            },
        },
        cdr:{
            cdrTodayTitle: "Today CDR",
            cdr30TodayTitle: "30 days CDR",
            billTime: "Billing Time",
            startTime: "Start Time",
            account: "Card ID",
            imsi: "IMSI",
            msisdn: "MSISDN",
            mccmnc: "MCCMNC",
            imei: "IMEI",
            sgsn: "SGSN",
            ratType: "Network Type",
            opId: "Operator ID",
            ccId: "Country Code",
            usage: "Usage",
            providerId: "Provider ID",
            agent: "Agent",
            productId: "Package ID",
            rate: "Rate",
            fee: "Fee",
            balanceAgent: "Agent Balance",
            requestType: "Request Type",
            usageIn: "Internet Usage",
            usageOut: "Download Usage",
            balance: "Balance"
        },
        accUserMsisdnPackage: 'User Msisdn Package',
        accUserBindMsisdn: 'User Bind Msisdn',
        bindMsisdn: 'Bind Msisdn'
    },
    oldFastQuery:{
        search: "Please input IMSI or card ID to search",
        basicInfo: "Basic Information",
        cardId: "Card ID",
        agent: "Agent",
        status: "Status",
        imsiStatusSCT:{
            noOpenAccount: "Not Open Account",
            inactive: "Inactive",
            activated: "Activated",
            locked: "Locked",
            close: "Closed",
            closing:"Closing"
        },
        imsiStatusMB:{
            inactive: "Inactive",
            activated: "Activated",
            expired: "Expired"
        },
        imsiStatusBICS:{
            inactive:'Inactive',
            activated:'Activated',
            freezed: 'Freezed'
        },
        simStatusObj:{
            inactive:'Inactive',
            published:'Published',
            activated:'Activated',
            expired: "Expired",
            disabled: 'Disabled',
            deleted: 'Deleted'
        },
        enable: "Available Or Not",
        location: "Activation  Area",
        openTime: "Account Open Time",
        actTime: "Activation Time",
        closeTime: "Close Time",
        expTime: "Expiration Time",
        simStatus: "SIM Status",
        productName: "Product Name",
        product:{
            information: "Package Information",
            productId: 'Package ID',
            productName: 'Product Name',
            days: 'Valid Days',
            pkgStatus: "Package Status",
            quota: 'Quota Data',
            usage: 'Usage Data',
            surplusFlow: 'Surplus Data',
            today: "Today Usage Data",
            source: "Roaming Area",
            openTime: "Open Time",
            createTime: "Create Time",
            expTime: "Expired Time",
            pkgUpTime: "Package Update Time",
            location:'Roaming Area',
            agent: "Agent",
            provider: "Provider",
            packageStatus:{
                inactive:'Inactive',
                activated:'Activated',
                expired:'Expired',
                close: 'Close',
                ReadyDelete:'Ready Delete'
            }
        },
        cdr: {
            cdrTodayTitle: "Today CDR",
            usage: "Usage Data",
            location: "Area",
            openTime: "Start Time",
            closeTime: "End Time"
        },

    },
    account: {
        startAccount: "Please enter the start card number search...",
        endAccount: "Please enter the end card number search...",
        startImsi: "Please enter the start imsi search...",
        endImsi: "Please enter the end imsi search....",
        agent: "Please enter agent search...",
        pleaseSelectAccount: "Please select card number",
        enableStatusPleaseSelect:' to enable, please reselect',
        disableStatusPleaseSelect:' to disable, please reselect',
        differentProviderNotice: 'Card provider is inconsistent with other provider, please re select!',
        diffrrentAgentNotice:'Card agent is inconsistent with other agent, please re select!',
        incorrectformat: 'Incorrent file format',
        excelFileFormatNotice: ' incorrect format. Please upload. XLS,. Xlsx file.',
        file: "The file",
        withdrawPackage: 'Withdraw package',
        areYouSure: 'Are you sure you want to withdraw the package?',
        nonsupportWithDraw:'The package cannot be withdrawn for the time being',
        noticeServiceRecharge:'One dollar commission for withdrawing the package. Are you sure to continue?',
        repeatRecharge:'This card package has been recharged several times, and the operation of withdrawal is not supported',
        withdrawFail:'Withdraw Failure',
        tempNotice:'A single batch recharge supports a maximum of 50 cards. Please ensure that the resources of each package are consistent with the card supplier.',
        topupTaskNotice:'A single batch recharge supports a maximum of 10000 cards. Please ensure that the resources of each package are consistent with the card supplier.',
        differentBossNotice:"Card class is inconsistent with other class, please re select!",
        balanceError: "The balance after deduction cannot be less than 0!",
        changeIpError: "Failed to get route!click ok to view details!",
        getIpGroupError: "Failed to get route!click ok to view details!",
        clearIpGroupError: "Failed to clear route!click ok to view details!",
        changeIpGroupError: "Failed to change route!click ok to view details!",
        searchIpGroupError: "Failed to search route!click ok to view details!",
    },
    assign: {
        startAccount: "Start Card Number",
        endAccount: "End Card Number",
        batchAssign: "Batch Assign",
        assignMerchant: "Merchant",
        pleaseStartAccount: "Please enter the start card number",
        count: "Count",
        pleaseEnterCount:'Please enter the count',
        pleaseEnterAccount:'Please enter the card number'
    },
    bindAssign:{
        requiredAccount: 'Required Card Number',
        requiredMerchant: 'Required Merchant',
        dataVerifiyFail: 'Data verification failed'
    },
    recharge:{
        cardNumberRecharge: "Card Number Recharge",
        latestPackage: 'Latest Package',
        use:"Use",
        superposition: 'Package Superposition',
        chargePackage:'Charge Package',
        extendedDays:'Extended Days',
        chargeAmount:'Charge Amount',
        changeIpFee: 'Change Route Amount',
        totalUsage:'Total Usage',
        rechargeInfo: 'Recharge Info',
        rechargeType: 'Type',
        packageSelect: 'Choose Package',
        renewalBasePackageSelect: 'Choose Target Package',
        renewalPackageSelect: 'Choose Renewal Product',
        pleaseChoosePackage: 'Please Choose Package',
        pleaseEnterDay:'Please Enter Day',
        pleaseEnterMoney:'Please Enter Money',
        pleaseEnterFlow:'Please Enter Flow',
        repeatPackageNotice: 'The latest package is the current package, please choose another package',
        refund:'Refund',
        flow: 'Flow',
        rechargeFlow:'Recharge flow',
        flowLimitType1: 'Unlimited flow package cannot be charged',
        flowLimitType2: 'The package has expired and cannot be charged',
        remark:'Recharge remark',
        title_1: 'Warning',
        message_1: 'Dear',
        message_2: ',your current balance ',
        message_3: 'is lower than alert threshold. you can recharge in advance if necessary',
        typeOptions: {
            add: 'Recharge Add',
            coverage: 'Recharge Coverage',
            merging: 'Recharge Merging',
            renewal: 'Recharge Renewal',
            flow: 'Recharge Flow',
            day: 'Recharge Days'
        },
        current_charge_log:'current recharge record',
        total_num:'total',
        success_num:'Number of successes',
        failed_num:'Number of failures',
        success_list:'Success List',
        loading_data:'Fetching data...',
        failed_list:'failure list',
        account_sn: "Card number",
        boss_package_id:'Boss package ID',
        result:' Result '
    },
    productList: {
        zoneName: 'Zone Name',
        zoneID: 'Zone ID',
        price: 'Price',
        actived: 'Actived',
        pleaseEnterZone:'Please enter zone name',
        pleaseEnterPackageID:'Please enter package ID',
        pleaseEnterPackageName:'Please enter package name',
    },
    statistics:{
        date: 'Date',
        selectDate: 'Select Date',
        accountCount: 'Total Cards',
        activatedAccountNum: 'Total Activated Cards',
        useUsage: 'Usage',
        userNum: 'Total User',
        hj:'Total'
    },
    log:{
        startTime: 'StartTime',
        endTime: 'EndTime',
        packagePrice: 'Package Price',
        prechangeAgentBalance: 'Pre-change Agent Balance',
        changedAgentBalance: 'Changed Agent Balance',
        changeAmount: 'Change Amount',
        description: 'Description',
        remark: 'Remark',
        operationTime: 'Operation Time',
        status: 'Status',
        success: 'Success',
        fail:'Fail',
        operator:'Operator',
        serviceCharge:'Handling Fee',
        numberOfSuccesses:'Number Of Successes',
        numberOfFailures:'Number Of Failures',
        packageDeduction:'Package Deduction',
        refund:'Refund',
        handlingFee :'Handling Fee',
        rechargeAmount:'Recharge Amount',
        accountBalance:'Account Balance',
        agentRechargeLog:'Agent Top-up Water',
        agentWithdrawLog:'Agent Withdraw Package Log',
        paymentSuccess:'Payment Success',
        rechargeSuccess:'Recharge Success',
        refundSuccess:'Refund Success',
        billingState:'Billing State',
        tId:'TID',
        otaRechargePackage:'OTA Charge Package',
        eSIMGenerateFee:'eSIM Generate Fee',
    },
    writeCardQuery:{
        totalNumCards:  'Total Num Cards',
        totalNumWritenCards:  'Total Num Writen Cards',
        totalNumWaitingCards:  'Total Num Waiting Cards',
        totalNumFailedCards:  'Total Num Failed Cards',
        totalNumUsedIMSIs:  'Total Num Used IMSIs',
        totalNumRepeatedCards:  'Total Num Repeated Cards',
        totalNumUnwrittenCards:  'Total Num Unwritten Cards',
        totalNumRecoveredCards:  'Total Num Recovered Cards',
        unwrittenCardInformation: 'Unwritten Card Information',
        repeatCardInformation: 'Repeat Card Information',
        repeatIMSIInformation: 'Repeat IMSI Information',
        waitingCardInformation: 'Waiting Card Information',
        failedCardInformation: 'Failed Card Information',
        recoveredCardCards: 'Recovered Card Cards',
        num: 'Num',
        pleaseenterKeyword: 'Please enter the start card number and end card number search',
        dateverify:'The start card number should be less than or equal to the end card number!'
    },
    merchant:{
        username:'Username',
        password:'Password',
        selectCombox: 'Please select',
        selectUsername:'Please select username',
        shopName:"Shop Name",
        pleaseEnterShopNameSearch:'Please enter shop name to search',
        editMerchant:'Edit Merchant',
        addMerchant:'Register Merchant',
        requiredUsername:'Required username',
        requiredPassword:'Required password',
        requiredRoleId:'Required role',
        requiredPasswordLength: 'Password length cannot be less than 6 digits',
        requiredMaxNameLength: "Maximum length of Product Name is 200 bytes",
        requiredShopName:'Required shop name',
        requiredAgent:'Required agent',
        correctFormatPhone:'Please enter a valid phone number'
    },
    agent:{
        username:'Username',
        password:'Password',
        nickname:'Nickname',
        role:'Role',
        balance:'Balance',
        alert_balance: 'Alert Balance',
        email: 'Email',
        remark: 'Remark',
        pleaseEnterUsernameSearch:'Please enter username to search',
        pleaseEnterNicknameSearch:'Please enter nickname to search',
        editAgent:'Edit Agent',
        registerAgent:'Register Agent',
        developing:'This feature is temporarily unavailable, under development',
        enable:'Enable',
        secret:'Secret',
        priceUnit: 'Currency',
        platform: 'Platform ',
        mgw_balance: 'Rate of data balance',
        parent_account: 'Parent agent account',
        per_mensem_last_time: 'Monthly Fee Date'
    },
    productImsi:{
        maximumSupportAuantity:'Support for maximal export of 10,000, are you sure you want to export?',
        agentResource:'Agency Package Resources',
        exportSuccess:'Export successful'
    },
    role:{
        roleName:'Role Name',
        roleCode:'Role Code',
        searchRole:'Please enter a role name search',
        description:'Description',
        addRole:'Add Role',
        editRole:'Edit Role',
        permission:'Permission',
        assignPermission:'Assign Permission',
        save:'Save',
        close:'Close',
        requiredRoleName:'Required Role Name',
        requiredRoleCode:'Required Role Code',
        home: 'Home',
        reload:'Please reload, try',
        saveSuccess:'Successfully saved'
    },
    actionLog:{
        usernameId:'Username ID',
        usernameSearch:'Please enter username to search',
        parametersSearch:'Please enter parameters to search',
        moduleName:'Module Name',
        requestMethod:'Request Method',
        requestParameters:'Request Parameters',
        requestPath:'Request Path',
        description:'Description',
        createTime:'CreateTime',
        seeParametersDetail:'See Parameters Detail',
        parameters:'Parameters'
    },
    taskTopup: {
        taskNo: 'Task No.',
        status: 'Status',
        uploadTask: 'Upload Task',
        uploadTopupFile: 'Upload topup file',
        topupMode: 'Mode',
        selectTopupMode: 'Please select the topup mode',
        topupAdd: 'Topup (add)',
        topupCover: 'Topup (cover)',
        topupRenewal: 'Topup (renewal)',
        uploadFile: 'Upload file',
        clickUpload: 'Click to upload',
        cardNo: 'Card No.',
        productId: 'Product ID',
        errorInfo: 'Exception information',
        topupSuccessList: 'Topup Successful List',
        topupFailList: 'Topup Failure List',
        cardCount: 'Card Total',
        fileCount: 'Upload Total',
        successCount: 'Success Total',
        failCount: 'Failed Total',
        taskTime: 'Time',
        agent: 'Agent',
        completeTime: 'Complete Time',
        createTime: 'Create Time',
        createDataDoing: 'Create data',
        completeCreateData: 'Data creation completed',
        checkDataDoing: 'Verifying data',
        checkDataFail: 'Verify data failed',
        topupDoing: 'Topup in progress',
        topupFail: 'Topup failed',
        completed: 'Completed',
        viewInfo: 'View',
        reUpload: 'Upload',
        downFile: 'Download',
        no: 'No.',
        information: 'Message',
        success: 'Successful',
        fail: 'Failed',
        topupTime: 'Topup Time',
        noOperatePermission: 'No permission to operate',
        pleaseUploadFile: 'Please upload the file',
        comfirmSubmitTask: 'Topup task, are you sure you want to submit it?',
        operateFailed: 'Operation failed',
        confirmSubmit: 'Are you sure you want to submit?',
        confirmDownFile: 'Are you sure you want to download the file?',
        loadingFailed: 'Load failed',
        clickView: 'Click view',
    },
    agentIpFeeLog: {
        date: 'Date',
        ipGroup: 'Lines',
        country: 'Countries',
        specifyIpRate: 'Specify Line Rate(/M)',
        specifyIpUsage: 'Specify Line Usage(M)',
        specifyIpFee: 'Specify Line Fee',
        otherRate: 'Other Line Rate(/M)',
        otherUsage: 'Other Line Usage(M)',
        otherFee: 'Other Line Fee',
        totalFee: 'Total Fee'
    },
    esimPurchase: 'Purchase Esim',
    esimPurchaseCommon: {
        purchaseStatus:{
            title: 'Status',
            inactive:'inactive',
            activated:'actived',
            completed: 'completed',
            stoped: 'stopped'
        },
        count: 'Purchase Quantity',
        successCount: 'Purchase Succeeds',
        failedCount: 'Purchase failed',
        faileMessage: 'Failure reason',
        product: 'Product',
        searchProduct: 'Product ID | Product name',
        purchase: 'Purchase',
        packageSelect: 'Product selection',
        packagePrice: 'Product price',
        noPackage: 'Product selection please',
        minCount: 'The minimum purchase quantity is 1',
        maxCount: 'The maximum purchase quantity is 1,000',
        noRemark: 'Please add a note.',
        email: 'Email',
        emailErr: 'The email is incorrect.',
        remark: 'Note',
        repeatSubmit: 'Order In progress, please do not repeat the operation.',
        purchaseSuccess: 'Purchase sucessfully',
        purchaseTime: 'Purchase datetime',
        purchaseStop: 'Stop the order',
        download: 'Download Esim',
        sendToEmail: 'Send to Email',
        purchaseDetail: 'Order Details',
        account: 'Account',
        qrcode: 'QR code',
        lpa: 'View eSIM Detail',
        sendToEmailSuccess: 'Send email success',
        sendToEmailFailed: 'Send email failed',
    }
};



// WEBPACK FOOTER //
// ./src/language/en-US.js